export const formatBirthDate = (birthDate: string) => {
	const pattern = /(\d{4})-(\d{2})-(\d{2})/;
	const replaced = "$3.$2.$1";
	return birthDate.replace(pattern, replaced);
};
